module.exports = __webpack_public_path__ + "img/exo-ape_665d6176a44cb9c477588e3f117514e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/exo-ape.jpg
// module id = 293
// module chunks = 0